import React from 'react';
import styles from './CostBasisToggle.module.css';

// Controlled segmented toggle for the profitability accounting basis on the
// internal (super-admin) cost dashboards. Mirrors CostPeriodFilter's pill
// pattern. The parent owns `basis` ('accrual' | 'cash'); both subtotals arrive in
// one payload, so flipping this never refetches.
const OPTIONS = [
  { key: 'accrual', label: 'Accrual', hint: 'All months, including the current open month (revenue + cost accrued to date)' },
  { key: 'cash', label: 'Cash', hint: 'Finalized (closed) months only — ignores the still-accruing current month' },
];

export default function CostBasisToggle({ basis, onBasis, ariaLabel = 'Profitability basis' }) {
  return (
    <div className={styles.bar} role="group" aria-label={ariaLabel}>
      {OPTIONS.map((o) => (
        <button
          key={o.key}
          type="button"
          className={`${styles.btn} ${basis === o.key ? styles.btnActive : ''}`}
          onClick={() => onBasis(o.key)}
          aria-pressed={basis === o.key}
          title={o.hint}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
